import React from 'react'

import { FeedbackMessage } from './FeedbackMessage/FeedbackMessage'
import style from './RegularButtonBox.module.css'

import { Button } from 'common/components'
import { useAppDispatch, useKeyDown } from 'common/hooks'
import { goToNextTask } from 'features/exam'

type PropsType = {
  isAnswered: boolean
  isSelectedAnswers: boolean
  submitAnswerHandler: () => void
}

export const RegularButtonBox = ({
  isAnswered,
  isSelectedAnswers,
  submitAnswerHandler,
}: PropsType) => {
  const dispatch = useAppDispatch()
  const skipQuestionHandler = () => {
    dispatch(goToNextTask())
  }

  const nextButtonHandler = () => {
    if (isAnswered) {
      dispatch(goToNextTask())
    }
  }

  useKeyDown(skipQuestionHandler, ' ')
  useKeyDown(nextButtonHandler, 'Enter')

  return (
    <div className={style['button-box']}>
      {isAnswered ? (
        <>
          <FeedbackMessage />
          <Button
            className={style['next-button']}
            type="button"
            accent
            onClick={skipQuestionHandler}
            title="Enter \ Space"
          >
            Далее
          </Button>
        </>
      ) : (
        <>
          <Button onClick={skipQuestionHandler} type="button" title="Space">
            Пропустить вопрос
          </Button>
          <Button
            type="button"
            onClick={submitAnswerHandler}
            accent
            disabled={!isSelectedAnswers}
            title="Enter"
          >
            Ответить
          </Button>
        </>
      )}
    </div>
  )
}
